import { Close, FilterSharp, GTranslate } from '@mui/icons-material';
import { Button, Card, CardHeader, CardActions, CardContent, Checkbox, FormControlLabel, IconButton, Modal, TextField, Typography, Tooltip, InputLabel, MenuItem, Select, FormControl, FormHelperText, SelectChangeEvent } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import SelectSingle from './SelectSingle';
import CnpjInput from './CnpjInput';
import object_nature from '../constants/natureza_objeto.json';
import body_name from '../constants/nome_orgao.json';
import body_type from '../constants/tipo_orgao.json';
import procurement_type from '../constants/tipo_licitacao.json';
import bidder_type from '../constants/tipo_vencedor.json';
import modality from '../constants/modalidade.json';
import cities from '../constants/cities.json';
import BidderNameInput from './BidderNameInput';
import SelectMultiple from './SelectMultiple';
import HelpIcon from '@mui/icons-material/Help';
import mesoregioes from "../constants/mesorregioes.json";
import microregioes from "../constants/microrregioes.json";
import comarcas from "../constants/comarcas.json";
import regioes_administrativas from "../constants/regioes_administrativas.json";
import { comarcasSelect, mesoregioesSelect, microregioesSelect, regionsSelect } from '../constants/selects';
import navbar_background from '../assets/navbar_background.svg';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import NumberFormat from "react-number-format";




type Props = {
    open: boolean,
    onClose: (() => void)
}

const groupsType = [
    { label: "Nenhum", value: " " },
    { label: "Mesoregião", value: "mesoregiao" },
    { label: "Microregião", value: "microregiao" },
    { label: "Comarca", value: "comarca" },
    { label: "Regiões Administrativas", value: "regioes administrativas" },
];
interface selectInterface {
    label: string,
    value: string,
}


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

function AdvancedFilter({ open, onClose }: Props) {

    const { filters, setFilters, cleanFilters } = useContext(GlobalStateContext);
    const { typedFilters, setTypedFilters } = useContext(GlobalStateContext);
    const [groupType, setGroupType] = useState<string>(" ");
    const [group, setGroup] = useState<selectInterface[]>([]);
    const [selectGroup, setSelectedGroup] = useState<string>("");
    const [entities, setEntities] = useState<string[]>([]);
    const [regions, setRegions] = useState<string[]>([]);
    const [disableGroup, setDisableGroup] = useState(true);
    const [disableEntity, setDisableEntity] = useState(true);
    const [allSelected, setAllSelected] = useState(false);
    const { selectAll, setSelectAll } = useContext(GlobalStateContext)
    const [selectAllInitially, setSelectAllInitially] = useState(false)


    const handleSend = () => {
        if (typeof typedFilters.min_amount !== 'undefined') {
            typedFilters.min_amount = parseFloat(typedFilters.min_amount.toString().replace(",", "."));
        }
        if (typeof typedFilters.max_amount !== 'undefined') {
            typedFilters.max_amount = parseFloat(typedFilters.max_amount.toString().replace(",", "."));
        }
        if (typeof typedFilters.min_homolog_price !== 'undefined') {
            typedFilters.min_homolog_price = parseFloat(typedFilters.min_homolog_price.toString().replace(",", "."));
        }
        if (typeof typedFilters.max_homolog_price !== 'undefined') {
            typedFilters.max_homolog_price = parseFloat(typedFilters.max_homolog_price.toString().replace(",", "."));
        }


        setFilters(typedFilters);
        onClose();
    }

    const changeCheck = () => {
        setTypedFilters({ ...typedFilters, ...{ skip_duplicates: !typedFilters.skip_duplicates } });
    }



    const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        if (ev.target.value == "") {
            setTypedFilters({ ...typedFilters, ...{ [ev.target.name]: undefined } });
        } else {
            setTypedFilters({ ...typedFilters, ...{ [ev.target.name]: ev.target.value } });
        }

    }

    useEffect(() => {
        setSelectAll(false);
        (async () => {

            setSelectedGroup("");
            if (groupType === " ") {
                let aux: string[] = [];
                cities[0].children.forEach(city => {
                    aux.push(city.label);
                });
                setEntities(aux);
                setDisableGroup(true);
                setDisableEntity(false);
            } else if (groupType === "mesoregiao") {
                setGroup(mesoregioesSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType === "microregiao") {
                setGroup(microregioesSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType == "comarca") {
                setGroup(comarcasSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            } else if (groupType == "") {
                setDisableEntity(true);
            } else {
                setGroup(regionsSelect);
                setDisableGroup(false);
                setDisableEntity(true);
            }
        })();

    }, [groupType]);

    useEffect(() => {
        setTypedFilters({
            ...typedFilters,
            'city': [],
        });
        setSelectAll(false);
        if (selectGroup != "") {
            if (groupType === "mesoregiao") {
                let aux = JSON.parse(JSON.stringify(mesoregioes));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFilters({
                    ...typedFilters,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else if (groupType === "microregiao") {
                let aux = JSON.parse(JSON.stringify(microregioes));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFilters({
                    ...typedFilters,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else if (groupType == "comarca") {
                let aux = JSON.parse(JSON.stringify(comarcas));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFilters({
                    ...typedFilters,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            } else {
                let aux = JSON.parse(JSON.stringify(regioes_administrativas));
                setEntities(aux[selectGroup].nome_cidade);
                setTypedFilters({
                    ...typedFilters,
                    'city': aux[selectGroup].nome_cidade,
                });
                setSelectAll(true);
                setDisableEntity(false);
            }


        }
    }, [selectGroup]);

    useEffect(() => {
        setTypedFilters(filters)
    }, [open])

    const handleChangeGroupType = (event: SelectChangeEvent) => {
        setGroupType(event.target.value);
    }

    const handleChangeSelectedGroup = (event: SelectChangeEvent) => {
        setSelectedGroup(event.target.value);
    }



    return (<Modal open={open} onClose={() => onClose()}>
        <div className="w-full h-full flex items-center justify-center">
            <Card className='w-full max-w-3xl relative'>
                <CardHeader
                    title="Filtros Avançados"
                    sx={{ color: 'white', bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}
                    titleTypographyProps={{ variant: 'h4' }}
                    action={
                        <IconButton onClick={(ev) => onClose()}>
                            <Close sx={{ color: 'white' }} />
                        </IconButton>
                    }>
                </CardHeader>
                <div className="h-[80vh] overflow-auto">
                    <CardContent>
                        <div className="mb-8">
                            <Typography variant='h5'>Faixa</Typography>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Quantidade Comprada</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name="min_amount" value={typedFilters.min_amount} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name="max_amount" value={typedFilters.max_amount} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                            <div className="my-4">
                                <Typography variant='subtitle2'>Preço Unitário</Typography>
                                <div className="flex gap-4 my-2">
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='min_homolog_price' value={typedFilters.min_homolog_price} onChange={handleChange} customInput={TextField} className='w-full' label="Min." variant="outlined" /></div>
                                    <div className='flex-1'><NumericFormat decimalSeparator="," name='max_homolog_price' value={typedFilters.max_homolog_price} onChange={handleChange} customInput={TextField} className='w-full' label="Max." variant="outlined" /></div>
                                </div>
                            </div>

                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Órgão</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='flex-1'>
                                    <SelectSingle filterKey='body' label='Nome do Órgão' options={body_name.children} searchable />
                                </div>
                                <div className='flex-1'>
                                    <SelectSingle filterKey='body_type' label='Tipo de Órgão' options={body_type.children} />
                                </div>
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Fornecedor</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='w-1/4'>
                                    <SelectSingle filterKey='bidder_type' label='Tipo' options={bidder_type.children} />
                                </div>
                                <div className='flex-1'>
                                    <BidderNameInput />
                                </div>
                                {filters.bidder_type === 'J' ?
                                    <div className='w-1/4'>
                                        <CnpjInput />
                                    </div>
                                    : null
                                }
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Licitação</Typography>
                            <div className="flex gap-4 my-2">
                                <div className='w-2/4'>
                                    <SelectSingle filterKey='procurement_type' label='Tipo de Licitação' options={procurement_type.children} />
                                </div>
                                <div className='flex-1'>
                                    <SelectSingle filterKey='modality' label='Modalidade' options={modality.children} />
                                </div>

                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Região</Typography>
                            <div className='my-4'>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="groupType">Tipo do Gupo</InputLabel>
                                    <Select
                                        labelId="groupType"
                                        id="groupType"
                                        value={groupType}
                                        label="Tipo do Grupo"
                                        displayEmpty={true}
                                        onChange={handleChangeGroupType}
                                    >
                                        {groupsType.map(({ label, value }) => (
                                            <MenuItem key={value} value={value}>{label}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="my-4">
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel id="group">Grupo</InputLabel>
                                    <Select
                                        labelId="group"
                                        id="group"
                                        value={selectGroup}
                                        label="Grupo"
                                        onChange={handleChangeSelectedGroup}
                                        disabled={disableGroup}
                                    >

                                        {group.map(({ label, value }) => (
                                            <MenuItem key={value} value={value}>{label}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="my-4">
                                <FormControl sx={{ width: '100%' }}>
                                    <SelectMultiple searchable disabled={disableEntity} filterKey='city' label='Entidade' options={entities.map(opt => opt)} closeButton />
                                </FormControl>
                            </div>
                        </div>

                        <div className="my-8">
                            <Typography variant='h5'>Busca</Typography>
                            <div className='my-4 flex'>
                                <Checkbox size='small' aria-label={'Remover Duplicidades'} onChange={changeCheck} checked={typedFilters.skip_duplicates} />
                                <Typography variant='h6' mt={0.6} color="initial">Remover Duplicidades</Typography>
                            </div>
                        </div>

                        <hr />
                    </CardContent>
                </div>
                <CardActions className='justify-end gap-2'>
                    <Button onClick={(ev) => { cleanFilters(); onClose(); setSelectedGroup(""); setGroupType("") }} variant='text'>Resetar</Button>
                    <Button onClick={handleSend} variant='contained'>Aplicar</Button>
                </CardActions>
            </Card>
        </div>
    </Modal >);
}

export default AdvancedFilter;

